<template>
  <div class="searchMore-container">
    <el-icon><Filter /></el-icon>高级搜索
    <div class="more-panel"></div>
  </div>
</template>

<script>
import { computed, defineComponent, reactive, toRefs, ref } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "searchMore",
  props: {
    title: {
      type: String,
      default: "页面标题",
    },
  },
  setup(props) {
    const route = useRoute();
    const searchReactive = reactive({
      keywords: "",
    });
    return {
      ...toRefs(searchReactive),
    };
  },
});
</script>

<style lang="less" scoped>
.searchMore-container {
  position: relative;
  // .more-panel{
  //     width: 100%;
  //     height: 500px;
  //     background-color: white;
  //     top: 0;
  //     left: 0;
  // }
}
</style>
